import moment from 'moment-timezone';

export class Timezone {
	public id: number;
	public name: string;
	public addDate: Date;
	public modifiedDate: Date;
	public modifiedUserId: string;
	public userId: string;
	public sortOrder: number;
	public countryId: number;
	public abbreviation: string;

	constructor(timezone: Timezone) {
		Object.assign(this, timezone);

		this.modifiedDate = this.modifiedDate ? new Date(moment(this.modifiedDate).format('MMM DD, YYYY hh:mm:ss a')) : this.modifiedDate;
		this.addDate = this.addDate ? new Date(moment(this.addDate).format('MMM DD, YYYY hh:mm:ss a')) : this.addDate;
	}
}
